// Static site content matching the Sportsbook Smasher reference design.

export const SPORTS = [
  { key: "football", label: "Football", league: "NFL" },
  { key: "basketball", label: "Basketball", league: "NBA" },
  { key: "baseball", label: "Baseball", league: "MLB" },
  { key: "hockey", label: "Hockey", league: "NHL" },
  { key: "soccer", label: "Soccer", league: "MLS" },
  { key: "boxing", label: "Boxing", league: "Boxing" },
  { key: "mma", label: "MMA", league: "UFC" },
];

export const TOP_PICKS = [
  { league: "NFL", pick: "CHIEFS -7.5", vs: "vs LV Raiders", odds: "-320", color: "#E31837", abbr: "KC" },
  { league: "NFL", pick: "RAVENS -6.5", vs: "vs CLE Browns", odds: "-280", color: "#241773", abbr: "BAL" },
  { league: "MLB", pick: "DODGERS ML", vs: "vs COL Rockies", odds: "-240", color: "#005A9C", abbr: "LAD" },
  { league: "MLB", pick: "YANKEES ML", vs: "vs CWS White Sox", odds: "-210", color: "#003087", abbr: "NYY" },
  { league: "MLB", pick: "BRAVES ML", vs: "vs MIA Marlins", odds: "-195", color: "#CE1141", abbr: "ATL" },
];

export const QUICK_ACCESS = [
  { label: "Today's Picks", icon: "target", to: "/picks" },
  { label: "Pick History", icon: "history", to: "/leaderboard" },
  { label: "Betting Tools", icon: "wrench", to: "/education" },
  { label: "Bankroll Tracker", icon: "wallet", to: "/education/bankroll-management" },
  { label: "Injury Reports", icon: "activity", to: "/news" },
  { label: "Discord Access", icon: "message-circle", to: "/membership" },
];

export const PERFORMANCE = {
  winStreak: 11,
  thisWeek: "+23.45u",
  thisMonth: "+87.32u",
  allTime: "+362.18u",
  last7Record: "18-6",
  last7Rate: 75,
};

export const RECENT_RESULTS = [
  { date: "5/11", league: "NFL", pick: "KC Chiefs -7.5", result: "WIN", units: "+1.00u" },
  { date: "5/11", league: "NBA", pick: "BOS Celtics -4.5", result: "WIN", units: "+1.05u" },
  { date: "5/10", league: "MLB", pick: "NY Yankees ML", result: "WIN", units: "+0.95u" },
  { date: "5/10", league: "NHL", pick: "COL Avalanche -1.5", result: "WIN", units: "+1.00u" },
  { date: "5/09", league: "SOCCER", pick: "Real Madrid ML", result: "WIN", units: "+1.10u" },
];

export const FEATURES_INCLUDED = [
  "Real-Time Odds Movement",
  "Expert Analysis & Trends",
  "Bankroll Management Tools",
  "24/7 Support",
];

export const PLANS = [
  {
    id: "starter",
    name: "STARTER SMASH",
    price: 29,
    tagline: "GET IN THE GAME.",
    style: "silver",
    cta: "JOIN STARTER SMASH",
    features: [
      "Daily Best Bet",
      "Sportsbook Analysis",
      "Injury & News Updates",
      "Betting Tools",
      "Pick History",
      "Bankroll Tracker",
      "Email Support",
    ],
  },
  {
    id: "pro",
    name: "PRO SMASHER",
    price: 69,
    tagline: "BRING THE HAMMER.",
    style: "gold",
    popular: true,
    cta: "JOIN PRO SMASHER",
    features: [
      "Everything in Starter Smash",
      "FREE Football Edition Ebook ($19.99 value)",
      "3-5 Premium Picks Daily",
      "Player Props",
      "Parlay Suggestions",
      "Live Betting Alerts",
      "Pro Smasher Analysis",
      "VIP Discord/Community",
      "Priority Support",
    ],
  },
];

export const TESTIMONIALS = [
  {
    quote:
      "Sportsbook Smasher has completely changed the way I bet. The picks, the alerts, the results — it's a whole different level.",
    author: "Q. Allen, Jacksonville, FL",
    role: "Verified Pro Smasher Member",
    stars: 5,
  },
  {
    quote: "Before Sportsbook Smasher, I mostly bet on my favorite teams. Now I bet smarter.",
    author: "H. West, Philadelphia",
    role: "Verified Pro Smasher",
    stars: 5,
  },
  {
    quote: "So far, so good. I use the OVER total strategy and I'm winning most of the time.",
    author: "C. Justice, Baltimore",
    role: "Verified Pro Smasher",
    stars: 5,
  },
];

export const VALUE_STRIP = [
  { title: "DATA DRIVEN", icon: "target", lines: ["Advanced analytics.", "Better decisions. More wins."] },
  { title: "EXPERT PICKS", icon: "shield", lines: ["Curated by sharp bettors", "who beat the books."] },
  { title: "THE SMASHER HAMMER™", icon: "hammer", lines: ["— BUILT TO BREAK ODDS.", "DESIGNED TO DELIVER WINS."], center: true },
  { title: "BANKROLL FIRST", icon: "dollar-sign", lines: ["Smart strategies.", "Long term success."] },
  { title: "24/7 SUPPORT", icon: "headphones", lines: ["We're here when", "you need us."] },
];

// ---- Education ----
export const EDUCATION_TOPICS = [
  {
    slug: "straight-bet",
    title: "What is a Straight Bet?",
    short: "The simplest wager — one team, one outcome.",
    body:
      "A Straight Bet is a wager on a single outcome of a single game or event. You pick one side (a team or player) and if that side wins, your bet wins. It is the foundation of sports betting. The correct term is STRAIGHT BET — it is a single, standalone wager with fixed odds at the time you place it.",
  },
  {
    slug: "over-under",
    title: "Understanding Over/Under",
    short: "Betting the combined total, not who wins.",
    body:
      "An Over/Under (or Total) bet is a wager on the combined score of both teams. The sportsbook posts a number; you bet whether the actual combined total will be OVER or UNDER that number. You are not betting on who wins — only on how many total points, runs, or goals are scored.",
  },
  {
    slug: "point-spread",
    title: "Understanding Point Spreads",
    short: "Leveling the field with a handicap.",
    body:
      "A Point Spread handicaps the favorite by a set number of points. The favorite must win by MORE than the spread to 'cover'; the underdog can lose by less than the spread (or win outright) to cover. Spreads exist to create balanced action on both sides of a matchup.",
  },
  {
    slug: "moneyline",
    title: "Understanding Moneylines",
    short: "Pick the winner, straight up.",
    body:
      "A Moneyline bet is simply picking who wins the game outright, with no spread. Favorites carry negative odds (risk more to win less) and underdogs carry positive odds (risk less to win more). It rewards you for correctly identifying the winner regardless of margin.",
  },
  {
    slug: "parlays",
    title: "Understanding Parlays",
    short: "Multiple bets, one ticket, bigger payout.",
    body:
      "A Parlay combines multiple bets into a single wager. Every leg (selection) must win for the parlay to pay out. Parlays offer larger payouts because they are harder to hit — the risk compounds with every leg you add. Understand that added legs sharply lower your probability of winning.",
  },
  {
    slug: "odds",
    title: "Understanding Odds",
    short: "American, decimal, and what they really mean.",
    body:
      "Odds tell you both the payout and the implied probability of an outcome. American odds use + and - (e.g. +150 or -200). Negative odds show how much you must risk to win $100; positive odds show how much you win on a $100 risk. Reading odds fluently is the first step to spotting value.",
  },
  {
    slug: "implied-probability",
    title: "Understanding Implied Probability",
    short: "Convert odds into a true win percentage.",
    body:
      "Implied probability is the win percentage the odds are suggesting. Converting odds to a percentage lets you compare the sportsbook's number against your own estimate. When your assessed probability is higher than the implied probability, that gap is where potential value lives.",
  },
  {
    slug: "line-movement",
    title: "Understanding Line Movement",
    short: "Why numbers move — and what it signals.",
    body:
      "Lines move as money comes in and as new information (injuries, weather, lineups) surfaces. Tracking line movement helps you understand where the market is leaning and whether the number you are getting is better or worse than the opening line.",
  },
  {
    slug: "bankroll-management",
    title: "Bankroll Management",
    short: "The discipline that keeps you in the game.",
    body:
      "Bankroll management is deciding in advance how much you are willing to risk and sizing each wager as a small, consistent unit of that total. Disciplined bankroll management protects you from chasing losses and is the single most important habit of long-term bettors. Only wager money you can afford to lose.",
  },
  {
    slug: "common-mistakes",
    title: "Common Betting Mistakes",
    short: "Avoid the traps that sink most bettors.",
    body:
      "Common mistakes include chasing losses, betting with emotion, ignoring the number you are getting, over-parlaying, and betting on too many games. Awareness of these patterns is the first step to avoiding them.",
  },
  {
    slug: "live-betting",
    title: "Live Betting",
    short: "Wagering while the game unfolds.",
    body:
      "Live (in-game) betting lets you wager on markets that update in real time as a game is played. It rewards bettors who can read momentum and game situations quickly. It also moves fast — discipline and a plan matter even more in-game.",
  },
  {
    slug: "reading-matchups",
    title: "Reading Matchups",
    short: "Analyze before you wager.",
    body:
      "Reading a matchup means studying pace, style, injuries, rest, situational spots, and how two teams' strengths and weaknesses interact. The goal is to understand the game before you make the wager — not to react to a logo or a name.",
  },
  {
    slug: "responsible-wagering",
    title: "Responsible Wagering",
    short: "Bet within your means, always.",
    body:
      "Responsible wagering means setting limits, never betting money you cannot afford to lose, and treating betting as entertainment — not income. No strategy guarantees a win. If gambling stops being fun or feels out of control, help is available (1-800-GAMBLER).",
  },
];

export const BET_TYPES = [
  {
    n: "01",
    name: "STRAIGHT BET",
    desc:
      "A wager on a single outcome of a single game. Pick one side; if it wins, you win. The foundation of every betting strategy. (The correct term is STRAIGHT BET.)",
  },
  {
    n: "02",
    name: "OVER / UNDER",
    desc:
      "A bet on the combined total score of both teams — not who wins. The book posts a number and you decide whether the real total finishes over or under it.",
  },
  {
    n: "03",
    name: "POINT SPREAD",
    desc:
      "A handicap applied to the favorite. They must win by more than the spread to cover; the underdog covers by keeping it close or winning outright.",
  },
];

export const STRATEGY_PILLARS = [
  { title: "Research First", body: "Study the matchup, the numbers, and the situation before you ever place a wager." },
  { title: "Discipline", body: "Stick to a plan and a unit size. Emotion is the fastest way to lose a bankroll." },
  { title: "Understand the Line", body: "Know what the number means and whether you're getting a good price." },
  { title: "Matchup Analysis", body: "Read pace, style, injuries and rest — not just team names." },
  { title: "Game Situations", body: "Spot, rest, travel, and motivation all shape outcomes." },
  { title: "Manage Bankroll", body: "Protect your capital so you can stay in the game long term." },
  { title: "Identify Value", body: "Look for gaps between your estimate and the book's implied probability." },
  { title: "Avoid Emotional Betting", body: "Never chase losses. Walk away and reassess with a clear head." },
];

export const EBOOK_LEARN = [
  "The three core bet types explained in plain English",
  "How odds, lines and totals actually work",
  "How to read a matchup before you wager",
  "Bankroll management and unit sizing",
  "A personal live Over betting approach (educational example)",
  "The most common mistakes — and how to avoid them",
];
